const fileBrowserErrorStatus = {
  BadFileName: 'BadFileName',
  BadFileSize: 'BadFileSize',
  BadFileType: 'BadFIleType',
  FileExists: 'FileExists',
  InsufficientSpace: 'InsufficientSpace',
  UploadFileErrorStructureInterrupted: 'UploadFileErrorStructureInterrupted',
  GeneralFileStructureError: 'GeneralFileStructureError',
  UnableToRenameFolderAlreadyExists: 'UnableToRenameFolderAlreadyExists',
  UnableToCreateFolderAlreadyExists: 'UnableToCreateFolderAlreadyExists',
  CreateFolderGeneralError: 'CreateFolderGeneralError',
  RenameFolderGeneralError: 'RenameFolderGeneralError',
  GeneralFileUploadError: 'GeneralFileUploadError',
  GeneralRequestException: 'GeneralRequestException',
  DeleteFileError: 'DeleteFileError',
  DeleteFolderError: 'DeleteFolderError'
};

export default fileBrowserErrorStatus;